import { Box, Typography } from "@mui/material";
import SideDrawer from "../../../Drawer/Drawer";

function ExclusionDrawer({ isOpen, setIsOpen, drawerData }) {
  return (
    <SideDrawer setIsOpen={setIsOpen} isOpen={isOpen}>
      <Box
        sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        <Box p={2}>
          <Typography fontSize={"22px"} fontWeight={"500"} textAlign={"center"}>
            Common Exclusions
          </Typography>
        </Box>
        <Box p={2} pt={4} width={"70%"}>
          <Box display={"flex"} justifyContent={"space-between"} paddingY={1}>
            <Typography>Consumables:</Typography>
            <Typography>
              {drawerData?.consumables ? "True" : "False"}
            </Typography>
          </Box>
          <Box display={"flex"} justifyContent={"space-between"} paddingY={1}>
            <Typography>Pharmacy:</Typography>
            <Typography>{drawerData?.pharmacy ? "True" : "False"}</Typography>
          </Box>
          <Box display={"flex"} justifyContent={"space-between"} paddingY={1}>
            <Typography>Consultation Fee:</Typography>
            <Typography>
              {drawerData?.consultationFee ? "True" : "False"}
            </Typography>
          </Box>
          <Box display={"flex"} justifyContent={"space-between"} paddingY={1}>
            <Typography>Registration Fee:</Typography>
            <Typography>
              {drawerData?.registrationFee ? "True" : "False"}
            </Typography>
          </Box>
          <Box display={"flex"} justifyContent={"space-between"} paddingY={1}>
            <Typography>Implants:</Typography>
            <Typography>{drawerData?.implants ? "True" : "False"}</Typography>
          </Box>
          <Box display={"flex"} justifyContent={"space-between"} paddingY={1}>
            <Typography>Other Deductions:</Typography>
            <Typography>
              {drawerData?.consultationFee ? "True" : "False"}
            </Typography>
          </Box>
        </Box>
      </Box>
    </SideDrawer>
  );
}

export default ExclusionDrawer;
